import { render, staticRenderFns } from "./card-M1.vue?vue&type=template&id=66738b6a&scoped=true&"
import script from "./card-M1.vue?vue&type=script&lang=js&"
export * from "./card-M1.vue?vue&type=script&lang=js&"
import style0 from "./card-M1.vue?vue&type=style&index=0&id=66738b6a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66738b6a",
  null
  
)

export default component.exports